import React from 'react';
import { Button, Grid, Popover } from '@mui/material';
import useFrameworkTranslation from 'framework/language/useFrameworkTranslation';

const SelectedColumnsButton = ({
  handleChangeCalculationKey,
  selectedColumns,
  invalidCalculationColumns,
  filteredColumns,
  columns
}) => {
  const { t } = useFrameworkTranslation();
  return (
    <>
      {selectedColumns.map((column) =>
        !invalidCalculationColumns.includes(column) ? (
          <Grid item xs={6} key={column}>
            <Button
              onClick={() =>
                handleChangeCalculationKey(filteredColumns[column])
              }
            >
              {t('table.calculate', {
                column: columns[filteredColumns[column]].label
              })}
            </Button>
          </Grid>
        ) : null
      )}
    </>
  );
};

const AryPopoverTableCalculation = React.forwardRef(
  (
    {
      open,
      handleClose,
      anchorPosition,
      handleChangeCalculationKey,
      selectedColumns,
      invalidCalculationColumns,
      filteredColumns,
      columns
    },
    ref
  ) =>
    selectedColumns?.length !== invalidCalculationColumns?.length && (
      <Popover
        ref={ref}
        PaperProps={{
          sx: {
            boxShadow: '.25rem .25rem .875rem 0 rgba(0, 0, 0, 0.1)'
          }
        }}
        open={open}
        anchorReference="anchorPosition"
        anchorPosition={anchorPosition}
        onClose={() => handleClose()}
      >
        <Grid container display="flex" direction="column" xs={12}>
          <SelectedColumnsButton
            handleChangeCalculationKey={handleChangeCalculationKey}
            selectedColumns={selectedColumns}
            invalidCalculationColumns={invalidCalculationColumns}
            filteredColumns={filteredColumns}
            columns={columns}
          />
        </Grid>
      </Popover>
    )
);

export default AryPopoverTableCalculation;
